/**
 * 用户分配选择器常量定义
 */
import {
  UserOutlined,
  TeamOutlined,
  ApartmentOutlined,
  SettingOutlined
} from '@ant-design/icons';

// 分配类型常量
export const ASSIGNMENT_TYPES = {
  STATIC_USER: 'static_user',
  STATIC_ROLE: 'static_role', 
  STATIC_DEPT: 'static_dept',
  DYNAMIC_USER_ROLE: 'dynamic_user_role',
  DYNAMIC_USER_DEPT: 'dynamic_user_dept',
  DYNAMIC_DEPT_ROLE: 'dynamic_dept_role',
  DYNAMIC_INITIATOR: 'dynamic_initiator',
  DYNAMIC_PREVIOUS: 'dynamic_previous',
  EXPRESSION: 'expression'
}

// 分配类型配置
export const ASSIGNMENT_TYPE_CONFIG = {
  [ASSIGNMENT_TYPES.STATIC_USER]: {
    label: '指定用户',
    icon: <UserOutlined />,
    description: '直接指定具体的用户作为候选人',
    color: 'blue',
    needsUserSelect: true
  },
  [ASSIGNMENT_TYPES.STATIC_ROLE]: {
    label: '指定角色',
    icon: <TeamOutlined />,
    description: '指定角色，该角色下的所有用户都是候选人',
    color: 'green',
    needsRoleSelect: true
  },
  [ASSIGNMENT_TYPES.STATIC_DEPT]: {
    label: '指定部门',
    icon: <ApartmentOutlined />,
    description: '指定部门，该部门下的所有用户都是候选人',
    color: 'orange',
    needsDeptSelect: true
  },
  [ASSIGNMENT_TYPES.DYNAMIC_USER_ROLE]: {
    label: '用户所属角色',
    icon: <SettingOutlined />,
    description: '运行时根据当前用户所属的角色确定候选人',
    color: 'purple',
    isDynamic: true
  },
  [ASSIGNMENT_TYPES.DYNAMIC_USER_DEPT]: {
    label: '用户所属部门',
    icon: <SettingOutlined />,
    description: '运行时根据当前用户所属的部门确定候选人',
    color: 'purple',
    isDynamic: true
  },
  [ASSIGNMENT_TYPES.DYNAMIC_DEPT_ROLE]: {
    label: '部门+角色',
    icon: <SettingOutlined />,
    description: '运行时根据指定部门和指定角色的交集确定候选人',
    color: 'purple',
    isDynamic: true,
    needsDeptSelect: true,
    needsRoleSelect: true
  },
  [ASSIGNMENT_TYPES.DYNAMIC_INITIATOR]: {
    label: '流程发起人',
    icon: <SettingOutlined />,
    description: '流程的发起人作为候选人',
    color: 'cyan',
    isDynamic: true
  },
  [ASSIGNMENT_TYPES.DYNAMIC_PREVIOUS]: {
    label: '上一节点处理人',
    icon: <SettingOutlined />,
    description: '上一个节点的处理人作为候选人',
    color: 'cyan',
    isDynamic: true
  },
  [ASSIGNMENT_TYPES.EXPRESSION]: {
    label: '表达式',
    icon: <SettingOutlined />,
    description: '使用自定义表达式动态确定候选人',
    color: 'red',
    isDynamic: true,
    needsExpression: true
  }
};